/**
 * Inline SVG for the landing chrome.
 *
 * Drawn here rather than shipped as files for the same reason the action bar
 * and the sign-out chrome draw theirs inline: they are 20 px, they must take
 * `currentColor` to follow hover and focus states, and four extra network
 * round trips on the one page whose whole job is to load fast is a bad trade.
 */

const SVG_OPEN = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"'
  + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">';

function stroked(paths: string): string {
  return `${SVG_OPEN}${paths}</svg>`;
}

/** Speaker with two arcs. */
export const ICON_SOUND_ON = stroked(
  '<path d="M4 9.5v5h3.2L12 18.6V5.4L7.2 9.5Z"/>'
  + '<path d="M15.6 9.1a4 4 0 0 1 0 5.8"/>'
  + '<path d="M18.1 6.4a7.6 7.6 0 0 1 0 11.2"/>',
);

/** Same speaker, arcs replaced by a cross — the shape reads as OFF at 19 px, a slash does not. */
export const ICON_SOUND_OFF = stroked(
  '<path d="M4 9.5v5h3.2L12 18.6V5.4L7.2 9.5Z"/>'
  + '<path d="m16.2 9.8 4.6 4.4"/><path d="m20.8 9.8-4.6 4.4"/>',
);

/** Three bars. */
export const ICON_MENU = stroked('<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>');

/** A cross, for closing the drawer. */
export const ICON_CLOSE = stroked('<path d="m6 6 12 12"/><path d="m18 6-12 12"/>');

/** A solid play triangle — the only filled glyph on the page, because the primary CTA earns it. */
export const ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">'
  + '<path d="M8 5.2v13.6L19 12Z"/></svg>';

/** Chevron pointing down — the hero scroll cue. */
export const ICON_CHEVRON_DOWN = stroked('<path d="m6 9.5 6 6 6-6"/>');
